import { Chip, Stack } from '@mui/material';
import React from 'react';
import {
    isOrderCompleted,
    logisticsChipColor,
    logisticsLabel,
    payoutChipColor,
    payoutLabel,
    productionChipColor,
    productionLabel,
} from '../../helpers/orderStages';

export default function OrderStageChips({ order, size = 'small' }) {
    if (!order) {
        return null;
    }
    return (
        <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
            <Chip
                size={size}
                color={productionChipColor(order.production_status)}
                label={`Produção: ${productionLabel(order.production_status)}`}
                variant={order.production_status === 'not_applicable' ? 'outlined' : 'filled'}
            />
            <Chip
                size={size}
                color={logisticsChipColor(order.logistics_status)}
                label={`Logística: ${logisticsLabel(order.logistics_status)}`}
                variant={order.logistics_status === 'not_applicable' ? 'outlined' : 'filled'}
            />
            <Chip
                size={size}
                color={order.payment_details?.paid ? 'success' : 'warning'}
                label={`Cliente: ${order.payment_details?.paid ? 'Pago' : 'Pendente'}`}
                variant={order.payment_details?.paid ? 'filled' : 'outlined'}
            />
            <Chip
                size={size}
                color={payoutChipColor(order.payout_status)}
                label={`Repasse: ${payoutLabel(order.payout_status)}`}
                variant={order.payout_status === 'not_applicable' ? 'outlined' : 'filled'}
            />
            {isOrderCompleted(order) ? (
                <Chip size={size} color="success" label="Concluído" />
            ) : null}
        </Stack>
    );
}
